export default __webpack_public_path__ + "static/media/bcaa.1df56c83.jpg";